import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'
import StatGraphs from '@shared/components/graphs'
import navStyles from '@shared/components/commonNav/style.module.scss'

const MatchDetailLiveStats = ({ data, matchDetail, is100, inningData }) => {
  const graphType = [
    {
      value: 'aWorm',
      label: 'Worm'
    },
    {
      value: 'aRunTypes',
      label: 'Runs'
    },
    {
      value: 'aWickets',
      label: 'Wickets'
    },
    {
      value: 'aExtras',
      label: 'Extras'
    },
    {
      value: 'aRunRates',
      label: 'Run Rate'
    },
    {
      value: 'aPartnership',
      label: 'partnerships'
    }
  ]

  function isDifferenceGreaterThan48Hours(date1, date2) {
    const diffInMilliseconds = new Date(date2) - new Date(date1)
    const diffInHours = diffInMilliseconds / (1000 * 60 * 60)
    return diffInHours > 48
  }
  const isGreaterThan48Hours = isDifferenceGreaterThan48Hours(matchDetail?.dStartDate, matchDetail?.dEndDate)

  if (!isGreaterThan48Hours) {
    graphType.unshift({
      value: 'aManhattan',
      label: 'Manhattan'
    })
  }

  const updatedArray = []

  for (let i = 0; i < graphType.length; i++) {
    const { value, label } = graphType[i]
    const hasValue = data.some(obj => obj[value]?.length > 0)

    if (hasValue) {
      updatedArray.push({ value, label })
    }
  }
  const filteredArray = updatedArray?.filter(item => item !== undefined)

  const finalArray = [
    ...filteredArray,
    { value: 'spider', label: 'Spider' },
    { value: 'wagonWheel', label: 'Wagon Wheel' }
    // ...(matchDetail?.oFormat?.sValue !== 'test' ? [{ value: 'winPercentage', navItem: 'Win-Percentage' }] : [])
  ]

  const [activeTab, setActiveTab] = useState(filteredArray[0]?.value)

  function activeTabHandler(e) {
    setActiveTab(e?.target?.id)
  }

  return (
    <>
      <Nav className={`${navStyles.commonNav} ${navStyles.pillsNav} justify-content-start mb-2 mt-2 mt-sm-0 flex-nowrap text-nowrap overflow-auto`} variant="pills">
        {
          finalArray?.map((type) => {
            return (
              <>
                <Nav.Item className={`${navStyles.item}`}>
                  <a
                    id={type?.value}
                    className={`${activeTab === type?.value && navStyles.active} nav-link`}
                    onClick={activeTabHandler}
                  >
                    {type?.label}
                  </a>
                </Nav.Item>
              </>
            )
          })
        }
      </Nav>
      <StatGraphs
        graphData={data}
        is100={is100}
        activeTab={activeTab}
        teamNames={matchDetail?.sTitle}
        matchDetail={matchDetail}
        inningData={inningData}
        isTestMatch={isGreaterThan48Hours}
      />
    </>
  )
}

MatchDetailLiveStats.propTypes = {
  data: PropTypes.array,
  matchDetail: PropTypes.array,
  is100: PropTypes.bool,
  inningData: PropTypes.object
}

export default MatchDetailLiveStats
